<template>
  <teleport 
    v-if="shareLinkModalDisplayed"
    to=".BcLayout"
  >
    <div
      class="ShareLinkModal fixed inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
          @click="close()"
        />
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div class="ShareLinkModalContent inline-block align-bottom bg-white rounded-lg p-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <h3 class="text-lg leading-6 font-bold text-gray-800">
            {{$t('Your link for sharing')}}
          </h3>
          <p class="text-sm text-gray-500">
            {{$t('Copy link to clipboard and enter for access')}}
          </p>
          <div class="w-full h-10 my-6 flex flex-row gap-2">
            <input
              ref="input"
              class="form-control form-control-gray w-auto h-full p-4 "
              type="text"
              :value="shareLink"
              readonly
              @click="selectInput()"
            />
            <button class="btn w-10 h-full border border-gray-300 hover:border-bc-blue rounded-md text-gray-400 hover:text-bc-blue">
              <aw-copy-to-clipboard 
                v-slot="{copy}"
                :text="shareLink"
              >
                <aw-icon 
                  icon="clipboard-copy" 
                  class="w-3 h-3"
                  @click="copy()"
                />
              </aw-copy-to-clipboard>
            </button>
          </div>
          <button
            type="button"
            class="btn btn-primary mt-3 w-full inline-flex justify-center sm:mt-0 sm:col-start-1 sm:text-sm"
            @click="close()"
          >
            {{$t('Close')}}
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { shareLink, shareLinkModalDisplayed } from './ShareFormContext'

export default {
  setup () {
    return {
      shareLink,
      shareLinkModalDisplayed,
    }
  },
  methods: {
    close() {
      this.shareLinkModalDisplayed = false
    },
    selectInput() {
      this.$refs.input.select()
    }
  },
}
</script>

<style lang="scss" scoped>
.ShareLinkModal {
  z-index: 9999;
}

input {
  padding: 0.5rem 0.75rem !important;
  width: calc(100% - 48px) !important;
}
</style>
